export function aroundIdQueryVariable(
  aroundId: string | undefined,
  paginationVariables: { after?: string; before?: string; first?: number; last?: number }
) {
  return paginationVariables.after || paginationVariables.before ? undefined : aroundId;
}

export function aroundIdMissingFromLoadedPage(
  aroundId: string | undefined,
  options: { loading: boolean; loadedNodeIds?: string[] }
) {
  if (!aroundId || options.loading || !options.loadedNodeIds) {
    return false;
  }

  return !options.loadedNodeIds.includes(aroundId);
}
